// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import axios from 'axios'
import i18n from './i18n/i18n'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
// import locale from 'element-ui/lib/locale/lang/en'
import locale from 'element-ui/lib/locale'
import echarts from 'echarts'
import store from './store/store'
import './assets/style/font.css'
import './assets/style/index.css'
import modal from './components/modal/index'
import lottie from 'vue-lottie'
import VueSocketIo from 'vue-socket.io'
import router from './router'

Vue.use(ElementUI, { locale })
Vue.config.productionTip = false

Vue.prototype.$echarts = echarts
/* eslint-disable no-new */

Vue.use(modal)

Vue.component('lottie', lottie)

Vue.config.productionTip = false

const socketUrl =
  process.env.NODE_ENV === 'production' ? 'https://saas.trustlook.com' : 'http://localhost:8081'
// const socketUrl =
//   process.env.NODE_ENV === 'production'
//     ? 'https://saas-kento.trustlook.com'
//     : 'http://localhost:8081'
console.log({ socketUrl }, process.env.NODE_ENV)
Vue.use(
  new VueSocketIo({
    debug: true,
    connection: socketUrl
  })
)

window.app = new Vue({
  el: '#app',
  router,
  store,
  i18n,
  components: { App },
  template: '<App/>'
})

export default () => {
  return axios.create({
    baseURL: `http://localhost:8081`
    // withCredentials: true
  })
}



// WEBPACK FOOTER //
// ./src/main.js